import { render } from "./DisplayFields.vue?vue&type=template&id=a44936d2&ts=true"
import script from "./DisplayFields.vue?vue&type=script&lang=ts"
export * from "./DisplayFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__